<template>
    <div class="award-options">
      <q-btn-dropdown
      label="Select your Undergraduate or Postgraduate Award"
      >
        <q-list>
          <q-item class="menu-heading-background" v-close-popup @click="onItemClick">
            <q-item-section>
              <q-item-label class="menu-heading"><b>Undergraduate</b></q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('LevelFiveAndSix', 'Undergraduate')">
            <q-item-section>
              <q-item-label>Level five and six</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('LevelSix', 'Undergraduate')">
            <q-item-section>
              <q-item-label>Level six only</q-item-label>
            </q-item-section>
          </q-item>
          <q-item class="menu-heading-background" v-close-popup @click="onItemClick">
            <q-item-section>
              <q-item-label class="menu-heading"><b>Postgraduate</b></q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('PgCert', 'Postgraduate')">
            <q-item-section>
              <q-item-label>Postgraduate Certificate (PgCert)</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('Masters', 'Postgraduate')">
            <q-item-section>
              <q-item-label>Master’s Degree</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('MasterOfLandscapeArchitecture', 'Postgraduate')">
            <q-item-section>
              <q-item-label>Master of Landscape Architecture</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('MasterOfArchitecture', 'Postgraduate')">
            <q-item-section>
              <q-item-label>Master of Architecture</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </div>
</template>

<script>
export default {
  setup (props, {emit}) {

      const onItemClick = (menuItem, heading) => {
         emit("menu", menuItem, heading)
      }

    return {
     onItemClick
    }
  }
}
</script>


